import { appConfig } from '@/config';
import type { Me } from '@/entities/me';
import type { AlertsFilters as Filters } from '@/types/alerts-filters';

import type { BlindingFilters } from './types';

export function getEmptyStateData(
  filters: Filters,
  me: Me,
): {
  blindingFilters: BlindingFilters;
} {
  const isWarningSelected = filters.alertStatusList?.includes('Warning');
  const isCriticalSelected = filters.alertStatusList?.includes('Critical');

  // Get effective default filters by merging app defaults with customer-specific overrides
  const effectiveDefaults = {
    ...appConfig.defaultAlertsFilters,
    ...me.config.defaultAlertsFilters,
  };

  // Check if any filter is actively restricting results
  const hasActiveFilters =
    // Time filter is restricting (less than default)
    filters.changedSinceDays < effectiveDefaults.changedSinceDays ||
    // Group filter is active
    (filters.groupIds && filters.groupIds.length > 0) ||
    // Alert status filter is restricting (not showing all statuses)
    (filters.alertStatusList &&
      effectiveDefaults.alertStatusList &&
      (filters.alertStatusList.length <
        effectiveDefaults.alertStatusList.length ||
        !effectiveDefaults.alertStatusList.every((status) =>
          filters.alertStatusList?.includes(status),
        ))) ||
    // Alert type filter is active
    (filters.alertTypeList && filters.alertTypeList.length > 0);

  const blindingFilters: BlindingFilters = {
    changedSinceDays: {
      isTooRecent: hasActiveFilters && filters.changedSinceDays <= 7,
    },
    groupIds: {},
    alertStatusList: {
      neitherSelected:
        hasActiveFilters &&
        filters.alertStatusList &&
        filters.alertStatusList.length > 0 &&
        !isWarningSelected &&
        !isCriticalSelected,
      onlyWarningSelected:
        hasActiveFilters && isWarningSelected && !isCriticalSelected,
      onlyCriticalSelected:
        hasActiveFilters && !isWarningSelected && isCriticalSelected,
    },
    alertTypeList: {
      isTooRestricted:
        hasActiveFilters &&
        filters.alertTypeList &&
        filters.alertTypeList.length > 0,
    },
  };

  return { blindingFilters };
}
